/* tslint:disable */
/* eslint-disable */
/**
 * Portal Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PatchRunFeedbackRequest interface.
 */
export function instanceOfPatchRunFeedbackRequest(value) {
    return true;
}
export function PatchRunFeedbackRequestFromJSON(json) {
    return PatchRunFeedbackRequestFromJSONTyped(json, false);
}
export function PatchRunFeedbackRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feedbackId': json['feedback_id'] == null ? undefined : json['feedback_id'],
        'isLike': json['is_like'] == null ? undefined : json['is_like'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
export function PatchRunFeedbackRequestToJSON(json) {
    return PatchRunFeedbackRequestToJSONTyped(json, false);
}
export function PatchRunFeedbackRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'feedback_id': value['feedbackId'],
        'is_like': value['isLike'],
        'comment': value['comment'],
    };
}
